// context/MenuContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

export const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuJustOpened, setMenuJustOpened] = useState(false);

  const toggleMenu = () => {
    if (!menuOpen) {
      // going from closed to open
      setMenuJustOpened(true);
    } else {
      // closing
      setMenuJustOpened(false);
    }
    setMenuOpen((prev) => !prev);
  };

  const value = {
    menuOpen,
    toggleMenu,
    setMenuOpen,
    menuJustOpened,
    setMenuJustOpened,
  };

  useEffect(() => {
    let timer;
    if (menuJustOpened) {
      timer = setTimeout(() => setMenuJustOpened(false), 600); // wait for animation
    }
    return () => clearTimeout(timer);
  }, [menuJustOpened]);

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};
